import axios from "axios";
import { getFirebaseIDToken } from "../functions/firebase/firebase";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const sendMarketingCampaignEmails = async (emails) => {
  const idToken = await getFirebaseIDToken();

  const response = await axios.post(`${API_BASE_URL}/api/marketing/campaign/dynamic`, emails, {
    headers: {
      Authorization: idToken,
      "Content-Type": "application/json",
    },
  });

  return response.data;
};

export const getMarketingEmailHistory = async (userId) => {
  const idToken = await getFirebaseIDToken();

  const response = await axios.get(`${API_BASE_URL}/api/marketing/history/${userId}`, {
    headers: {
      Authorization: idToken,
    },
  });

  return response.data;
};
